import { useContext } from "react";
import { AuthEmpleadoContext } from "../../../context/AuthEmpleadoContext";

function PerfilEmpleado() {
  const { empleado } = useContext(AuthEmpleadoContext);

  if (!empleado) return null;

  return (
    <div
      className="modal fade"
      id="perfilEmpleado"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content rounded-4 border-0 shadow-lg">

          {/* HEADER */}
          <div
            className="modal-header text-white"
            style={{ background: "rgb(61, 102, 81)" }}
          >
            <h5 className="modal-title fw-bold">
              👤 Perfil del Empleado
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
            ></button>
          </div>

          {/* BODY */}
          <div className="modal-body p-4">

            <div className="row g-4">

              {/* Avatar */}
              <div className="col-md-4 text-center">
                <div
                  className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center mx-auto shadow"
                  style={{ width: 120, height: 120, fontSize: 40 }}
                >
                  {empleado.nombre.charAt(0)}
                </div>

                <h5 className="mt-3 fw-bold">
                  {empleado.nombre} {empleado.apellido}
                </h5>

                <span className="badge bg-secondary mt-2">
                  {empleado.rol}
                </span>
              </div>

              {/* Datos */}
              <div className="col-md-8">

                <div className="row g-3">

                  <div className="col-6">
                    <div className="border rounded-3 p-3 bg-light">
                      <small className="text-muted">CUIT</small>
                      <div className="fw-semibold">
                        {empleado.cuit}
                      </div>
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="border rounded-3 p-3 bg-light">
                      <small className="text-muted">Email</small>
                      <div className="fw-semibold">
                        {empleado.mail}
                      </div>
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="border rounded-3 p-3 bg-light">
                      <small className="text-muted">Estado</small>
                      <div className="fw-semibold text-success">
                        Activo
                      </div>
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="border rounded-3 p-3 bg-light">
                      <small className="text-muted">Tipo de Cuenta</small>
                      <div className="fw-semibold">
                        Empleado
                      </div>
                    </div>
                  </div>

                </div>

              </div>

            </div>

          </div>

          {/* FOOTER */}
          <div className="modal-footer">
            <button
              className="btn btn-outline-secondary rounded-pill"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default PerfilEmpleado;
